export default {
  stats: {
    title: "Stats",
    tabs: {
      team: "Stats d'équipe",
      player: "Stats joueur",
    },
    empty: {
      unavailable: "Les stats ne sont pas disponibles pour le moment.",
    },
    filters: {
      titles: {
        qualifier: "Mode",
        type: "Type",
        position: "Position",
      },
      plurals: {
        qualifier: "Modes",
        type: "Types",
        position: "Positions",
      },
      options: {
        qualifier: {
          averageStats: "Par match",
          cumulativeStats: "Total",
        },
        type: {
          offensive: "Offensif",
          defensive: "Défensif",
        },
      },
    },
  },
};
